/**
 * Haptic feedback helper using the Vibration API.
 * Falls back silently when not supported (iOS Safari, desktop).
 * Respects prefers-reduced-motion.
 */

const prefersReducedMotion = () =>
  typeof window !== "undefined" &&
  window.matchMedia?.("(prefers-reduced-motion: reduce)")?.matches;

const vibrate = (pattern: number | number[]) => {
  if (prefersReducedMotion()) return;
  if (typeof navigator === "undefined" || !("vibrate" in navigator)) return;
  try {
    navigator.vibrate(pattern);
  } catch {
    /* noop */
  }
};

export const haptics = {
  light: () => vibrate(10),
  medium: () => vibrate(20),
  heavy: () => vibrate(40),
  success: () => vibrate([15, 50, 15]),
  warning: () => vibrate([20, 80, 20]),
  error: () => vibrate([40, 60, 40, 60, 40]),
  selection: () => vibrate(5),
};
